export enum SetupHostedNumberStep {
  NOT_STARTED = -1,
  CHECK_ELIGIBILITY = 0,
  CREATE_ORDER = 1,
  VERIFICATION = 2,
  ATTACH_DOCUMENTS = 3,
  SUCCESS = 4,
}

export type SetupHostedNumberStepStatus = 'pending' | 'in-progress' | 'completed' | 'error';
